import { isEmpty } from "lodash";
import { staticAssetUrl } from "@circle-react/config/Settings";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { useThemeContext } from "@circle-react/providers";

export const Cover = () => {
  const { isDarkAppearance } = useThemeContext();
  const { paywall } = usePaywallCheckoutContext();

  const event = paywall.event;

  if (!event) {
    return null;
  }

  const {
    cover_image_url: coverImageUrl,
    cover_image: coverImage,
    cover_image_variants: coverImageVariants,
  } = event;

  if (!coverImageUrl || !coverImage) {
    return null;
  }

  const coverImageFallbackUrl = isDarkAppearance
    ? staticAssetUrl("dark-mode-cover-thumbnail-2x.png")
    : staticAssetUrl("light-mode-cover-thumbnail-2x.png");

  const imgSrcUrl = coverImageUrl || coverImageFallbackUrl;
  const shouldUseFallback = isEmpty(coverImageVariants) ? false : true;

  const properties = {
    src: shouldUseFallback ? coverImageVariants.original : imgSrcUrl,
    ...(shouldUseFallback
      ? {
          srcSet: `${coverImageVariants.medium} 640w, ${coverImageVariants.large} 768w, ${coverImageVariants.original} 1024w`,
        }
      : {}),
  };

  return (
    <img
      loading="lazy"
      alt=""
      className="relative w-full rounded-t-xl object-cover"
      {...properties}
    />
  );
};
